<template>
  <div class="project-desc flex-box">
    <div class="title">{{ descInfo.title }}</div>
    <div class="description">{{ descInfo.description }}</div>
    <div class="project-content">
      <span>{{ descInfo.redContent }}</span>{{ descInfo.content }}

      <div class="project-img" v-if="descInfo.img">
        <img v-lazy="descInfo.img" alt="">
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    descInfo: {
      type: Object,
      default: () => {
        return {
          title: '',
          description: '',
          redContent: '',
          content: '',
          img: null
        }
      }
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.project-desc {
  padding: 9rem 26rem 9rem;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 4.2rem;
  }

  .project-content {
    width: 138rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 2.2rem;
    color: #333333;
    line-height: 3.6rem;
    text-align: left;
    font-style: normal;
    span {
      color: #FB0000;
    }
    .project-img {
      width: 100%;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .project-desc {
    padding: 4.8rem 1.6rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
    .project-content {
      width: 100%;
      font-size: 1.5rem;
      line-height: 2.6rem;
    }
  }
}
</style>
